;(function($) {

var selectors = {
    row: '[data-repeatable-row]',
    controls: {
        container: '[data-repeatable-controls]',
        buttons: {
            add: '[data-repeatable-control-button=add]',
            remove: '[data-repeatable-control-button=remove]'
        }
    }
};
var index = 0;
var inject = function(element) {
    $(element).html($(element).html().replace(/\{\{index\}\}/g, index));
    ++index;
};
var clone = function(element) {
    var cloned = $(element).clone(true, true);
    cloned.find(selectors.controls.container).show();
    inject(cloned);
    return cloned;
};
var repeatable = function() {
    $(this).each(function() {
        var container = $(this);
        var row = container.find(selectors.row);
        var clonable = row.clone(true, true);
        container.find(selectors.controls.container).hide();
        container.on('click', selectors.controls.buttons.add, function(event) {
            event.preventDefault();
            container.find(selectors.row).last().after(clone(clonable));
        });
        container.on('click', selectors.controls.buttons.remove, function(event) {
            event.preventDefault();
            $(this).closest(selectors.row).remove();
        });
        inject(row);
    });
    return this;
};

$.fn.repeatable = repeatable;

})(jQuery);